/**
 * Get the variant names of an enum as an array
 */
export function enumKeys(e) {
    return Object.keys(e).filter((item) => {
        // biome-ignore lint/suspicious/noGlobalIsNan: Good isNan
        return isNaN(Number(item));
    });
}
export function enumValues(e) {
    const keys = enumKeys(e);
    return keys.map((k) => e[k]);
}
//# sourceMappingURL=enum.js.map